import React from "react"

function Breakdown(props) {
  return (
    <div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Breakdown</th>
            <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>Tax</td>
            <td>$ {props.tax}</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Savings</td>
            <td>$ {props.saving}</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Investments</td>
            <td>$ {props.investment}</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Expenses</td>
            <td>$ {props.expense}</td>
          </tr>
          
        </tbody>
      </table>
    </div>
  )
}

export default Breakdown
